<template>
  <div class="dept-manage">
    <page-header title="部门管理" icon="el-icon-office-building" />
    
    <!-- 搜索区域 -->
    <el-card class="search-card">
      <div class="card-title">
        <i class="el-icon-search"></i>
        <span>筛选查询</span>
      </div>
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="部门名称">
          <el-input v-model="searchForm.name" placeholder="请输入部门名称" clearable class="filter-item"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="部门状态" clearable class="filter-item">
            <el-option label="正常" value="正常"></el-option>
            <el-option label="停用" value="停用"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="filter-buttons">
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 数据列表 -->
    <el-card class="table-card">
      <div class="card-title">
        <i class="el-icon-tickets"></i>
        <span>数据列表</span>
      </div>
      
      <!-- 操作按钮 -->
      <div class="operation-bar">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      </div>

      <!-- 表格区域 -->
      <el-table
        v-loading="tableLoading"
        :data="tableData"
        row-key="id"
        border
        :tree-props="{children: 'children'}"
        style="width: 100%; margin: 0"
        element-loading-text="加载中..."

       
      >
        <el-table-column 
          prop="name" 
          label="部门名称" 
          width="230" 
          align="center"
        ></el-table-column>
        <el-table-column 
          prop="charger" 
          label="部门联系人" 
          width="230" 
          align="center"
        ></el-table-column>
        
        <el-table-column 
          prop="charger_phone" 
          label="联系电话" 
          width="230" 
          align="center"
        ></el-table-column>
        
        <el-table-column  
          prop="charger_email" 
          label="电子邮箱" 
          width="230" 
          align="center"
        ></el-table-column>
        <el-table-column 
          prop="status" 
          label="状态" 
          width="120" 
          align="center"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '正常' ? 'success' : 'danger'">
              {{ scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column 
          prop="createTime" 
          label="创建时间" 
          min-width="250"
          align="center"
        ></el-table-column>
        <el-table-column 
          label="操作" 
          width="220"
          align="center" 
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">修改</el-button>
            <el-button type="text" size="small" @click="handleAddSub(scope.row)">新增</el-button>
            <el-button 
              v-if="!isRootDepartment(scope.row)"
              type="text" 
              size="small" 
              @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/修改部门对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="上级部门" prop="parentId">
          <el-select v-model="form.parentId" placeholder="选择上级部门" style="width: 100%">
            <el-option label="根节点" value="0"></el-option>
            <el-option 
              v-for="dept in departmentOptions" 
              :key="dept.id"
              :label="dept.name"
              :value="dept.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="charger">
          <el-input v-model="form.charger" placeholder="请输入负责人"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="charger_phone">
          <el-input v-model="form.charger_phone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="charger_email">
          <el-input v-model="form.charger_email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="显示排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" controls-position="right" placeholder="10"></el-input-number>
        </el-form-item>
        <el-form-item label="部门状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio label="正常">正常</el-radio>
            <el-radio label="停用">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import PageHeader from '@/components/common/PageHeader'

export default {
  name: 'DepartmentManage',
  components: {
    PageHeader
  },
  data() {
    return {
      searchForm: {
        name: '',
        status: ''
      },
      tableData: [],
      loading: false,
      dialogVisible: false,
      dialogTitle: '',
      form: {
        id: '',
        deptId: '',
        parentId: '0',
        name: '',
        charger: '',
        charger_phone: '',
        charger_email: '',
        sort: '1',
        status: '正常'
      },
      rules: {
        
        name: [
        { required: true, message: '请输入部门名称', trigger: 'blur' },
        { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ],
        parentId: [
          { required: true, message: '请选择上级部门', trigger: 'change' }
        ],
        sort: [
          { required: false, message: '请输入显示排序', trigger: 'blur' }
        ],
        charger: [
          { required: true, message: '请输入负责人', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        charger_phone: [
          {  required: true,pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        charger_email: [
          {  required: true,type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.fetchDepartmentList()
   
  },
  methods: {
    // 获取部门列表
    async fetchDepartmentList() {
      // 清空数据并显示加载状态
      this.tableData = []
      this.tableLoading = true
      
      try {
        const res = await request({
          url: '/api/v1/dept/list',
          method: 'POST',
          data: {
            name: this.searchForm.name,
            status: this.searchForm.status === '' ? -1 : 
                   this.searchForm.status === '正常' ? 1 : 0
          }
        })
        
        if (res.status === 1) {
          this.tableData = this.formatDepartmentData(res.data)
        } else {
          this.$message.error(res.msg || '获取部门列表失败')
        }
      } catch (error) {
        console.error('获取部门列表错误:', error)
        this.$message.error(error.message || '获取部门列表失败')
      } finally {
        // 无论成功失败都关闭加载状态
        this.tableLoading = false
      }
    },

    // 格式化部门数据
formatDepartmentData(list) {
  // 1. 先将所有数据格式化成统一格式
  const formattedList = list.map(item => ({
    id: item.dept_id,
    parentId: item.parent_id,
    name: item.dept_name,
    sort: item.sort,
    status: item.status === 1 ? '正常' : '停用',
    createTime: this.formatDateTime(item.created_at),
    charger: item.charger,
    charger_phone: item.charger_phone,
    charger_email: item.charger_email,
    children: []
  }))

  // 2. 创建一个映射表，用于快速查找部门
  const deptMap = {}
  formattedList.forEach(dept => {
    deptMap[dept.id] = dept
  })

  // 3. 构建树形结构
  const tree = []
  formattedList.forEach(dept => {
    if (dept.parentId === '0') {
      // 顶级部门直接加入树中
      tree.push(dept)
    } else {
      // 将子部门添加到父部门的children中
      const parent = deptMap[dept.parentId]
      if (parent) {
        parent.children.push(dept)
      }
    }
  })

  return tree
},

    // // 格式化部门数据
    // formatDepartmentData(list) {
    //   return list.map(item => ({
    //     id: item.dept_id,
    //     parentId: item.parent_id,
    //     name: item.dept_name,
    //     sort: item.sort,
    //     status: item.status === 1 ? '正常' : '停用',
    //     createTime: this.formatDateTime(item.created_at),
    //     charger: item.charger,
    //     charger_phone: item.charger_phone,
    //     charger_email: item.charger_email,
    //     children: item.children ? this.formatDepartmentData(item.children) : []
    //   }))
    // },

    // 搜索async
  handleSearch() {
      this.fetchDepartmentList()
      console.log(this.tableData)
     
    },

    // 重置
    handleReset() {
      this.searchForm = {
        name: '',
        status: ''
      }
      this.fetchDepartmentList()
    },

    // 保存部门
    async submitForm() {
      try {
        await this.$refs.form.validate()
        const res = await request({
          url: '/api/v1/dept/save',
          method: 'POST',
          data: {
            deptId: this.form.deptId,
            parentId: this.form.parentId,
            deptName: this.form.name,
            orderNum: this.form.sort,
            status: this.form.status === '正常' ? 1 : 0,
            charger: this.form.charger,
            charger_phone: this.form.charger_phone,
            charger_email: this.form.charger_email
          }
        })

        if (res.status === 1) {
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.fetchDepartmentList()
        }
      } catch (error) {
        console.error('保存部门错误:', error)
        this.$message.error(error.message || '保存失败')
      }
    },

    // 删除部门
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该部门?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const res = await request({
          url: `/api/v1/dept/delete/${row.id}`,
          method: 'GET'
        })
        
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.fetchDepartmentList()
        } else {
          this.$message.error(res.msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除部门错误:', error)
          this.$message.error('删除失败')
        }
      }
    },

    // 处理新增部门按钮点击
    handleAdd() {
      this.dialogTitle = '新增部门'
      this.form = {
        deptId: '',
        parentId: '0',
        name: '',
        charger: '',
        charger_phone: '',
        charger_email: '',
        phone: '',
        email: '',
        sort: 10,
        status: '正常'
      }
      this.dialogVisible = true
    },

    // 处理添加子部门按钮点击
    handleAddSub(row) {
      this.dialogTitle = '新增子部门'
      this.form = {
        deptId: '',
        parentId: row.id,
        name: '',
        charger: '',
        charger_phone: '',
        charger_email: '',
        sort: 10,
        status: '正常'
      }
      this.dialogVisible = true
    },

    // 处理编辑部门按钮点击
    handleEdit(row) {
      this.dialogTitle = '修改部门'
      this.form = {
        deptId: row.id,
        parentId: row.parentId,
        name: row.name,
        charger: row.charger,
        charger_phone: row.charger_phone,
        charger_email: row.charger_email,
        sort: row.sort,
        status: row.status
      }
      this.dialogVisible = true
    },

    // 判断是否为根部门
    isRootDepartment(row) {
      return row.parentId === '0'
    },

    // 时间格式化函数
    formatDateTime(date) {
      if (!date) return ''
      const d = new Date(date)
      
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hour = String(d.getHours()).padStart(2, '0')
      const minute = String(d.getMinutes()).padStart(2, '0')
      const second = String(d.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    }
  },
  computed: {
    departmentOptions() {
      // 将树形数据转换为扁平数组
      const flattenDepts = (depts) => {
        let result = []
        depts.forEach(dept => {
          result.push({
            id: dept.id,
            name: dept.name
          })
          if (dept.children && dept.children.length) {
            result = result.concat(flattenDepts(dept.children))
          }
        })
        return result
      }
      return flattenDepts(this.tableData)
    }
  }
}
</script>

<style lang="scss" scoped>
.dept-manage {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 84px);

  .search-card,
  .table-card {
    background: #fff;
    border-radius: 4px;
    margin-bottom: 20px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
    padding: 0;
  }

  .card-title {
    border-bottom: 1px solid #ebeef5;
    padding: 15px 20px;
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 500;
    color: #303133;
  }

  .card-title i {
    margin-right: 8px;
    color: #409EFF;
  }

  .filter-item {
    width: 200px;
  }

  .filter-buttons {
    margin-left: 10px;
  }

  .operation-bar {
    margin: 0 20px 20px;
  }

  .el-table {
    margin: 0 !important;
    width: 100% !important;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  }

  /* 表格单元格样式 */
  :deep(.el-table td) {
    padding: 16px 0;  /* 增加单元格上下间距 */
  }

  /* 表格头部样式 */
  :deep(.el-table th) {
    padding: 14px 0;
    background-color: #fafafa;  /* 更柔和的表头背景色 */
    font-weight: 600;  /* 加粗表头文字 */
    color: #1f2d3d;  /* 更深的表头文字颜色 */
    border-bottom: 1px solid #ebeef5;  /* 添加表头底部边框 */
  }

  /* 表格行hover效果 */
  :deep(.el-table tr:hover td) {
    background-color: #f5f7fa;
  }

  /* 表格内容对齐方式 */
  :deep(.el-table .cell) {
    padding: 0 10px;
  }

  /* 操作列按钮样式 */
  :deep(.el-table .el-button--text) {
    padding: 0 8px;  /* 调整文字按钮间距 */
  }

  :deep(.el-table .el-button--text + .el-button--text) {
    margin-left: 8px;  /* 调整操作按钮之间的间距 */
  }

  /* 状态标签样式优化 */
  :deep(.el-tag) {
    padding: 0 12px;
    height: 24px;
    line-height: 24px;
  }

  /* 表格展开图标样式 */
  :deep(.el-table__expand-icon) {
    margin-right: 8px;
  }

  /* 部门名称列样式 */
  :deep(.el-table .el-table__row td:first-child .cell) {
    padding-left: 20px;
    justify-content: flex-start;
  }

  /* 操作栏样式优化 */
  .operation-bar {
    margin: 0;
    padding: 16px 20px;
    border-bottom: 1px solid #ebeef5;
  }

  /* 表格外边距调整 */
  .table-card {
    margin-bottom: 24px;
    padding: 0;
  }

  /* 表格内容垂直对齐 */
  :deep(.el-table td .cell) {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 40px;
  }

  /* 表格行样式 */
  :deep(.el-table__row) {
    transition: all 0.3s ease;  /* 添加过渡效果 */
  }

  .dialog-footer {
    text-align: right;
  }

  .el-button + .el-button {
    margin-left: 10px;
  }

  /* 修改卡片标题样式 */
  .card-title {
    margin-bottom: 0;
    padding: 15px 20px;
    border-bottom: 1px solid #ebeef5;
  }
}
</style> 